export const businessInfo = {
  name: 'Kreata Designs',
  tagline: 'Professional Design & Graphics Services',
  address: 'Jogoo Road, Nairobi, Kenya',
  phone: '+254 700 022761',
  phoneLink: 'tel:+254700022761',
  whatsappNumber: '254700022761',
  whatsappLink: 'https://wa.me/254700022761',
  hours: {
    online: 'Online Support: 24/7',
    inPerson: 'Mon – Sat: 7:00 AM – 7:00 PM',
  },
  social: {
    instagram: 'https://www.instagram.com/kretadesigns/',
    tiktok: 'https://www.tiktok.com/@kreatadesigns',
  },
  mapEmbedUrl: 'https://www.google.com/maps?q=Jogoo+Road,+Nairobi,+Kenya&output=embed',
};

export const teamInfo = {
  directors: [
    { name: 'Emmanuel', title: 'Director' },
    { name: 'Joseph', title: 'Director' },
    { name: 'Peter', title: 'Director' },
  ],
  keyStaff: [
    {
      name: 'Simala Watts',
      title: 'Chief Web Developer',
      phone: '0718902699',
      phoneLink: 'tel:+254718902699',
    },
  ],
};

export const whyUsPoints = [
  {
    title: 'Expert Design Team',
    description:
      'Our experienced designers create stunning logos, branding, and marketing materials tailored to your vision and business goals.',
  },
  {
    title: 'Quality Print Services',
    description:
      'From business cards and flyers to large format banners, we deliver crisp, vibrant prints using premium materials and techniques.',
  },
  {
    title: 'Fast, Reliable Turnaround',
    description:
      'Most design and printing jobs are completed quickly. For complex projects, we keep you updated every step of the way.',
  },
  {
    title: 'Affordable, Transparent Pricing',
    description:
      'No hidden charges. We explain costs upfront so you always know what you\'re paying for your design work.',
  },
  {
    title: 'Friendly, Professional Team',
    description:
      'Our staff are trained to understand your needs, offer creative solutions, and handle your projects with care and attention to detail.',
  },
  {
    title: 'Always Within Reach',
    description:
      'Visit us on Jogoo Road, or reach out anytime via WhatsApp — our team is ready to help bring your ideas to life.',
  },
];